import { render } from "./KryptonPopinRedirection.vue?vue&type=template&id=4a1be09e&lang=pug"
import script from "./KryptonPopinRedirection.vue?vue&type=script&lang=js"
export * from "./KryptonPopinRedirection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__